"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: stock/stock-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fstock%2Fstock-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInstrumentCategoriesRequest = exports.GetCountriesResponse = exports.GetCountriesRequest = exports.Country = exports.GetViolationsSummaryResponse = exports.ViolationsSummary = exports.GetViolationsSummaryRequest = exports.GetStatementFileResponse = exports.GetStatementFileRequest = exports.GetTaxDocumentsResponse = exports.GetTaxDocumentsRequest = exports.GetTradeConfirmationsResponse = exports.GetTradeConfirmationsRequest = exports.GetMonthlyStatementsResponse = exports.GetMonthlyStatementsRequest = exports.StatementFile = exports.GetAccountActivityResponse = exports.GetAccountActivityRequest = exports.GetUserRiskLevelResponse = exports.GetUserRiskLevelRequest = exports.SetUserRiskLevelResponse = exports.SetUserRiskLevelRequest = exports.SearchInstrumentsResponse = exports.SearchInstrumentsRequest = exports.GetMarketHoursResponse = exports.GetMarketHoursRequest = exports.CancelOrderResponse = exports.CancelOrderRequest = exports.GetOrdersResponse = exports.GetOrdersRequest = exports.GetOrderResponse = exports.GetOrderRequest = exports.CreateOrderResponse = exports.CreateOrderRequest = exports.GetNbboQuoteResponse = exports.GetNbboQuoteRequest = exports.GetOrderQuoteResponse = exports.GetOrderQuoteRequest = exports.GetQuotesResponse = exports.GetQuotesRequest = exports.GetAccountPositionsResponse = exports.GetAccountPositionsRequest = exports.GetHistoricalPriceDataResponseDeprecated = exports.GetHistoricalPriceDataRequestDeprecated = exports.GetChartResponse = exports.GetChartRequest = exports.GetInstrumentDetailsResponse = exports.GetInstrumentDetailsRequest = exports.ChartTimeRange = exports.ChartCompression = void 0;
exports.StockServiceClient = exports.chartTimeRangeToJSON = exports.chartTimeRangeFromJSON = exports.chartCompressionToJSON = exports.chartCompressionFromJSON = exports.GetAccountPerformanceResponse = exports.GetAccountPerformanceRequest = exports.AccountPerformance = exports.GetTrendingCategoryResponse = exports.GetTrendingCategoryRequest = exports.GetAssociatedInstrumentsResponse = exports.GetAssociatedInstrumentsRequest = exports.GetInstrumentCategoriesResponse = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const stock_order_1 = require("../common/stock-order");
const paging_1 = require("../paging/paging");
const activity_item_1 = require("../txactivity/activity-item");
const stock_1 = require("./stock");
const protobufPackage = 'com.step.stock.proto';
var ChartCompression;
(function (ChartCompression) {
    ChartCompression["INVALID_CHART_COMPRESSION"] = "INVALID_CHART_COMPRESSION";
    ChartCompression["DAY"] = "DAY";
    ChartCompression["MINUTE"] = "MINUTE";
    ChartCompression["FIVE_MINUTES"] = "FIVE_MINUTES";
    ChartCompression["THIRTY_MINUTES"] = "THIRTY_MINUTES";
    ChartCompression["HOUR"] = "HOUR";
    ChartCompression["WEEK"] = "WEEK";
    ChartCompression["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ChartCompression || (exports.ChartCompression = ChartCompression = {}));
var ChartTimeRange;
(function (ChartTimeRange) {
    ChartTimeRange["INVALID_CHART_TIME_RANGE"] = "INVALID_CHART_TIME_RANGE";
    ChartTimeRange["ONE_DAY"] = "ONE_DAY";
    ChartTimeRange["ONE_WEEK"] = "ONE_WEEK";
    ChartTimeRange["ONE_MONTH"] = "ONE_MONTH";
    ChartTimeRange["THREE_MONTHS"] = "THREE_MONTHS";
    ChartTimeRange["ONE_YEAR"] = "ONE_YEAR";
    ChartTimeRange["FIVE_YEARS"] = "FIVE_YEARS";
    ChartTimeRange["ALL_TIME"] = "ALL_TIME";
    ChartTimeRange["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ChartTimeRange || (exports.ChartTimeRange = ChartTimeRange = {}));
function createBaseGetInstrumentDetailsRequest() {
    return { symbol: '' };
}
exports.GetInstrumentDetailsRequest = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        return obj;
    },
    create(base) {
        return exports.GetInstrumentDetailsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetInstrumentDetailsRequest();
        message.symbol = object.symbol ?? '';
        return message;
    },
};
function createBaseGetInstrumentDetailsResponse() {
    return {
        details: stock_1.InstrumentDetails.fromPartial({}),
        risk: stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK,
        categoryIds: [],
    };
}
exports.GetInstrumentDetailsResponse = {
    fromJSON(object) {
        const message = {
            details: isSet(object.details)
                ? stock_1.InstrumentDetails.fromJSON(object.details)
                : stock_1.InstrumentDetails.fromPartial({}),
            categoryIds: globalThis.Array.isArray(object?.categoryIds)
                ? object.categoryIds.map((e) => globalThis.String(e))
                : [],
        };
        if (isSet(object.risk)) {
            message.risk = (0, stock_1.instrumentRiskFromJSON)(object.risk);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = stock_1.InstrumentDetails.toJSON(message.details);
        }
        if (message.risk !== undefined && message.risk !== stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK) {
            obj.risk = (0, stock_1.instrumentRiskToJSON)(message.risk);
        }
        if (message.categoryIds?.length) {
            obj.categoryIds = message.categoryIds;
        }
        return obj;
    },
    create(base) {
        return exports.GetInstrumentDetailsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetInstrumentDetailsResponse();
        message.details = (object.details !== undefined && object.details !== null)
            ? stock_1.InstrumentDetails.fromPartial(object.details)
            : stock_1.InstrumentDetails.fromPartial({});
        message.risk = object.risk ?? stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK;
        message.categoryIds = object.categoryIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetChartRequest() {
    return { instrumentId: '', timeRange: ChartTimeRange.INVALID_CHART_TIME_RANGE };
}
exports.GetChartRequest = {
    fromJSON(object) {
        const message = {
            instrumentId: isSet(object.instrumentId) ? globalThis.String(object.instrumentId) : '',
            timeRange: isSet(object.timeRange)
                ? chartTimeRangeFromJSON(object.timeRange)
                : ChartTimeRange.INVALID_CHART_TIME_RANGE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrumentId !== '') {
            obj.instrumentId = message.instrumentId;
        }
        if (message.timeRange !== ChartTimeRange.INVALID_CHART_TIME_RANGE) {
            obj.timeRange = chartTimeRangeToJSON(message.timeRange);
        }
        return obj;
    },
    create(base) {
        return exports.GetChartRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChartRequest();
        message.instrumentId = object.instrumentId ?? '';
        message.timeRange = object.timeRange ?? ChartTimeRange.INVALID_CHART_TIME_RANGE;
        return message;
    },
};
function createBaseGetChartResponse() {
    return { prices: [] };
}
exports.GetChartResponse = {
    fromJSON(object) {
        const message = {
            prices: globalThis.Array.isArray(object?.prices)
                ? object.prices.map((e) => stock_1.Price.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.prices?.length) {
            obj.prices = message.prices.map((e) => stock_1.Price.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetChartResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChartResponse();
        message.prices = object.prices?.map((e) => stock_1.Price.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetHistoricalPriceDataRequestDeprecated() {
    return {
        instrumentId: '',
        startMs: '0',
        endMs: '0',
        compression: ChartCompression.INVALID_CHART_COMPRESSION,
    };
}
exports.GetHistoricalPriceDataRequestDeprecated = {
    fromJSON(object) {
        const message = {
            instrumentId: isSet(object.instrumentId) ? globalThis.String(object.instrumentId) : '',
            startMs: isSet(object.startMs) ? globalThis.String(object.startMs) : '0',
            endMs: isSet(object.endMs) ? globalThis.String(object.endMs) : '0',
            compression: isSet(object.compression)
                ? chartCompressionFromJSON(object.compression)
                : ChartCompression.INVALID_CHART_COMPRESSION,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrumentId !== '') {
            obj.instrumentId = message.instrumentId;
        }
        if (message.startMs !== '0') {
            obj.startMs = message.startMs;
        }
        if (message.endMs !== '0') {
            obj.endMs = message.endMs;
        }
        if (message.compression !== ChartCompression.INVALID_CHART_COMPRESSION) {
            obj.compression = chartCompressionToJSON(message.compression);
        }
        return obj;
    },
    create(base) {
        return exports.GetHistoricalPriceDataRequestDeprecated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetHistoricalPriceDataRequestDeprecated();
        message.instrumentId = object.instrumentId ?? '';
        message.startMs = object.startMs ?? '0';
        message.endMs = object.endMs ?? '0';
        message.compression = object.compression ?? ChartCompression.INVALID_CHART_COMPRESSION;
        return message;
    },
};
function createBaseGetHistoricalPriceDataResponseDeprecated() {
    return { prices: [] };
}
exports.GetHistoricalPriceDataResponseDeprecated = {
    fromJSON(object) {
        const message = {
            prices: globalThis.Array.isArray(object?.prices)
                ? object.prices.map((e) => stock_1.Price.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.prices?.length) {
            obj.prices = message.prices.map((e) => stock_1.Price.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetHistoricalPriceDataResponseDeprecated.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetHistoricalPriceDataResponseDeprecated();
        message.prices = object.prices?.map((e) => stock_1.Price.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetAccountPositionsRequest() {
    return {};
}
exports.GetAccountPositionsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAccountPositionsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAccountPositionsRequest();
        return message;
    },
};
function createBaseGetAccountPositionsResponse() {
    return { positions: undefined };
}
exports.GetAccountPositionsResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.positions)) {
            message.positions = stock_1.AccountPositions.fromJSON(object.positions);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.positions !== undefined) {
            obj.positions = stock_1.AccountPositions.toJSON(message.positions);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountPositionsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountPositionsResponse();
        message.positions = (object.positions !== undefined && object.positions !== null)
            ? stock_1.AccountPositions.fromPartial(object.positions)
            : undefined;
        return message;
    },
};
function createBaseGetQuotesRequest() {
    return { symbols: [] };
}
exports.GetQuotesRequest = {
    fromJSON(object) {
        const message = {
            symbols: globalThis.Array.isArray(object?.symbols)
                ? object.symbols.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbols?.length) {
            obj.symbols = message.symbols;
        }
        return obj;
    },
    create(base) {
        return exports.GetQuotesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuotesRequest();
        message.symbols = object.symbols?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetQuotesResponse() {
    return { quotes: [] };
}
exports.GetQuotesResponse = {
    fromJSON(object) {
        const message = {
            quotes: globalThis.Array.isArray(object?.quotes)
                ? object.quotes.map((e) => stock_1.EquityQuote.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quotes?.length) {
            obj.quotes = message.quotes.map((e) => stock_1.EquityQuote.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetQuotesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuotesResponse();
        message.quotes = object.quotes?.map((e) => stock_1.EquityQuote.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetOrderQuoteRequest() {
    return { symbol: '', side: stock_order_1.Side.INVALID_SIDE, quantity: undefined, total: undefined };
}
exports.GetOrderQuoteRequest = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            side: isSet(object.side) ? (0, stock_order_1.sideFromJSON)(object.side) : stock_order_1.Side.INVALID_SIDE,
        };
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = amount_1.Amount.fromJSON(object.total);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.side !== stock_order_1.Side.INVALID_SIDE) {
            obj.side = (0, stock_order_1.sideToJSON)(message.side);
        }
        if (message.quantity !== undefined) {
            obj.quantity = message.quantity;
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.GetOrderQuoteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOrderQuoteRequest();
        message.symbol = object.symbol ?? '';
        message.side = object.side ?? stock_order_1.Side.INVALID_SIDE;
        message.quantity = object.quantity ?? undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : undefined;
        return message;
    },
};
function createBaseGetOrderQuoteResponse() {
    return { quote: stock_1.OrderQuote.fromPartial({}) };
}
exports.GetOrderQuoteResponse = {
    fromJSON(object) {
        const message = {
            quote: isSet(object.quote) ? stock_1.OrderQuote.fromJSON(object.quote) : stock_1.OrderQuote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quote !== undefined) {
            obj.quote = stock_1.OrderQuote.toJSON(message.quote);
        }
        return obj;
    },
    create(base) {
        return exports.GetOrderQuoteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOrderQuoteResponse();
        message.quote = (object.quote !== undefined && object.quote !== null)
            ? stock_1.OrderQuote.fromPartial(object.quote)
            : stock_1.OrderQuote.fromPartial({});
        return message;
    },
};
function createBaseGetNbboQuoteRequest() {
    return { symbol: '' };
}
exports.GetNbboQuoteRequest = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        return obj;
    },
    create(base) {
        return exports.GetNbboQuoteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetNbboQuoteRequest();
        message.symbol = object.symbol ?? '';
        return message;
    },
};
function createBaseGetNbboQuoteResponse() {
    return { quote: stock_1.NbboQuote.fromPartial({}) };
}
exports.GetNbboQuoteResponse = {
    fromJSON(object) {
        const message = {
            quote: isSet(object.quote) ? stock_1.NbboQuote.fromJSON(object.quote) : stock_1.NbboQuote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quote !== undefined) {
            obj.quote = stock_1.NbboQuote.toJSON(message.quote);
        }
        return obj;
    },
    create(base) {
        return exports.GetNbboQuoteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetNbboQuoteResponse();
        message.quote = (object.quote !== undefined && object.quote !== null)
            ? stock_1.NbboQuote.fromPartial(object.quote)
            : stock_1.NbboQuote.fromPartial({});
        return message;
    },
};
function createBaseCreateOrderRequest() {
    return { symbol: '', side: stock_order_1.Side.INVALID_SIDE, quantity: undefined, total: undefined };
}
exports.CreateOrderRequest = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            side: isSet(object.side) ? (0, stock_order_1.sideFromJSON)(object.side) : stock_order_1.Side.INVALID_SIDE,
        };
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = amount_1.Amount.fromJSON(object.total);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.side !== stock_order_1.Side.INVALID_SIDE) {
            obj.side = (0, stock_order_1.sideToJSON)(message.side);
        }
        if (message.quantity !== undefined) {
            obj.quantity = message.quantity;
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderRequest();
        message.symbol = object.symbol ?? '';
        message.side = object.side ?? stock_order_1.Side.INVALID_SIDE;
        message.quantity = object.quantity ?? undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : undefined;
        return message;
    },
};
function createBaseCreateOrderResponse() {
    return { orderId: '' };
}
exports.CreateOrderResponse = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateOrderResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateOrderResponse();
        message.orderId = object.orderId ?? '';
        return message;
    },
};
function createBaseGetOrderRequest() {
    return { orderId: '' };
}
exports.GetOrderRequest = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        return obj;
    },
    create(base) {
        return exports.GetOrderRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOrderRequest();
        message.orderId = object.orderId ?? '';
        return message;
    },
};
function createBaseGetOrderResponse() {
    return { order: stock_order_1.Order.fromPartial({}) };
}
exports.GetOrderResponse = {
    fromJSON(object) {
        const message = {
            order: isSet(object.order) ? stock_order_1.Order.fromJSON(object.order) : stock_order_1.Order.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.order !== undefined) {
            obj.order = stock_order_1.Order.toJSON(message.order);
        }
        return obj;
    },
    create(base) {
        return exports.GetOrderResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOrderResponse();
        message.order = (object.order !== undefined && object.order !== null)
            ? stock_order_1.Order.fromPartial(object.order)
            : stock_order_1.Order.fromPartial({});
        return message;
    },
};
function createBaseGetOrdersRequest() {
    return {};
}
exports.GetOrdersRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetOrdersRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetOrdersRequest();
        return message;
    },
};
function createBaseGetOrdersResponse() {
    return { orders: [] };
}
exports.GetOrdersResponse = {
    fromJSON(object) {
        const message = {
            orders: globalThis.Array.isArray(object?.orders)
                ? object.orders.map((e) => stock_order_1.Order.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orders?.length) {
            obj.orders = message.orders.map((e) => stock_order_1.Order.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetOrdersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOrdersResponse();
        message.orders = object.orders?.map((e) => stock_order_1.Order.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCancelOrderRequest() {
    return { orderId: '' };
}
exports.CancelOrderRequest = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        return obj;
    },
    create(base) {
        return exports.CancelOrderRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelOrderRequest();
        message.orderId = object.orderId ?? '';
        return message;
    },
};
function createBaseCancelOrderResponse() {
    return {};
}
exports.CancelOrderResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CancelOrderResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCancelOrderResponse();
        return message;
    },
};
function createBaseGetMarketHoursRequest() {
    return {};
}
exports.GetMarketHoursRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetMarketHoursRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetMarketHoursRequest();
        return message;
    },
};
function createBaseGetMarketHoursResponse() {
    return { currentTimestampMs: '0', isOpen: false, nextOpenTimestampMs: '0' };
}
exports.GetMarketHoursResponse = {
    fromJSON(object) {
        const message = {
            currentTimestampMs: isSet(object.currentTimestampMs)
                ? globalThis.String(object.currentTimestampMs)
                : '0',
            isOpen: isSet(object.isOpen) ? globalThis.Boolean(object.isOpen) : false,
            nextOpenTimestampMs: isSet(object.nextOpenTimestampMs)
                ? globalThis.String(object.nextOpenTimestampMs)
                : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currentTimestampMs !== '0') {
            obj.currentTimestampMs = message.currentTimestampMs;
        }
        if (message.isOpen !== false) {
            obj.isOpen = message.isOpen;
        }
        if (message.nextOpenTimestampMs !== '0') {
            obj.nextOpenTimestampMs = message.nextOpenTimestampMs;
        }
        return obj;
    },
    create(base) {
        return exports.GetMarketHoursResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMarketHoursResponse();
        message.currentTimestampMs = object.currentTimestampMs ?? '0';
        message.isOpen = object.isOpen ?? false;
        message.nextOpenTimestampMs = object.nextOpenTimestampMs ?? '0';
        return message;
    },
};
function createBaseSearchInstrumentsRequest() {
    return {
        query: '',
        type: stock_1.InstrumentType.INVALID_INSTRUMENT_TYPE,
        risk: stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK,
        limit: 0,
        types: [],
    };
}
exports.SearchInstrumentsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.query)) {
            message.query = globalThis.String(object.query);
        }
        if (isSet(object.type)) {
            message.type = (0, stock_1.instrumentTypeFromJSON)(object.type);
        }
        if (isSet(object.risk)) {
            message.risk = (0, stock_1.instrumentRiskFromJSON)(object.risk);
        }
        if (isSet(object.limit)) {
            message.limit = globalThis.Number(object.limit);
        }
        if (globalThis.Array.isArray(object?.types)) {
            message.types = object.types.map((e) => (0, stock_1.instrumentTypeFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.query !== undefined && message.query !== '') {
            obj.query = message.query;
        }
        if (message.type !== undefined && message.type !== stock_1.InstrumentType.INVALID_INSTRUMENT_TYPE) {
            obj.type = (0, stock_1.instrumentTypeToJSON)(message.type);
        }
        if (message.risk !== undefined && message.risk !== stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK) {
            obj.risk = (0, stock_1.instrumentRiskToJSON)(message.risk);
        }
        if (message.limit !== undefined && message.limit !== 0) {
            obj.limit = Math.round(message.limit);
        }
        if (message.types?.length) {
            obj.types = message.types.map((e) => (0, stock_1.instrumentTypeToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.SearchInstrumentsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchInstrumentsRequest();
        message.query = object.query ?? '';
        message.type = object.type ?? stock_1.InstrumentType.INVALID_INSTRUMENT_TYPE;
        message.risk = object.risk ?? stock_1.InstrumentRisk.INVALID_INSTRUMENT_RISK;
        message.limit = object.limit ?? 0;
        message.types = object.types?.map((e) => e) || [];
        return message;
    },
};
function createBaseSearchInstrumentsResponse() {
    return { instruments: [] };
}
exports.SearchInstrumentsResponse = {
    fromJSON(object) {
        const message = {
            instruments: globalThis.Array.isArray(object?.instruments)
                ? object.instruments.map((e) => stock_1.InstrumentsSearchResult.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instruments?.length) {
            obj.instruments = message.instruments.map((e) => stock_1.InstrumentsSearchResult.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SearchInstrumentsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchInstrumentsResponse();
        message.instruments = object.instruments?.map((e) => stock_1.InstrumentsSearchResult.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseSetUserRiskLevelRequest() {
    return { riskLevel: stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL };
}
exports.SetUserRiskLevelRequest = {
    fromJSON(object) {
        const message = {
            riskLevel: isSet(object.riskLevel)
                ? (0, stock_1.portfolioRiskLevelFromJSON)(object.riskLevel)
                : stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.riskLevel !== stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL) {
            obj.riskLevel = (0, stock_1.portfolioRiskLevelToJSON)(message.riskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.SetUserRiskLevelRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUserRiskLevelRequest();
        message.riskLevel = object.riskLevel ?? stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL;
        return message;
    },
};
function createBaseSetUserRiskLevelResponse() {
    return { riskLevel: stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL };
}
exports.SetUserRiskLevelResponse = {
    fromJSON(object) {
        const message = {
            riskLevel: isSet(object.riskLevel)
                ? (0, stock_1.portfolioRiskLevelFromJSON)(object.riskLevel)
                : stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.riskLevel !== stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL) {
            obj.riskLevel = (0, stock_1.portfolioRiskLevelToJSON)(message.riskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.SetUserRiskLevelResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUserRiskLevelResponse();
        message.riskLevel = object.riskLevel ?? stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL;
        return message;
    },
};
function createBaseGetUserRiskLevelRequest() {
    return {};
}
exports.GetUserRiskLevelRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserRiskLevelRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserRiskLevelRequest();
        return message;
    },
};
function createBaseGetUserRiskLevelResponse() {
    return { riskLevel: stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL };
}
exports.GetUserRiskLevelResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.riskLevel)) {
            message.riskLevel = (0, stock_1.portfolioRiskLevelFromJSON)(object.riskLevel);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.riskLevel !== undefined && message.riskLevel !== stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL) {
            obj.riskLevel = (0, stock_1.portfolioRiskLevelToJSON)(message.riskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserRiskLevelResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserRiskLevelResponse();
        message.riskLevel = object.riskLevel ?? stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL;
        return message;
    },
};
function createBaseGetAccountActivityRequest() {
    return { paging: undefined };
}
exports.GetAccountActivityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountActivityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountActivityRequest();
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetAccountActivityResponse() {
    return { activities: [], paging: undefined };
}
exports.GetAccountActivityResponse = {
    fromJSON(object) {
        const message = {
            activities: globalThis.Array.isArray(object?.activities)
                ? object.activities.map((e) => activity_item_1.ActivityItem.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activities?.length) {
            obj.activities = message.activities.map((e) => activity_item_1.ActivityItem.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountActivityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountActivityResponse();
        message.activities = object.activities?.map((e) => activity_item_1.ActivityItem.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseStatementFile() {
    return { fileKey: '', displayName: '' };
}
exports.StatementFile = {
    fromJSON(object) {
        const message = {
            fileKey: isSet(object.fileKey) ? globalThis.String(object.fileKey) : '',
            displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fileKey !== '') {
            obj.fileKey = message.fileKey;
        }
        if (message.displayName !== '') {
            obj.displayName = message.displayName;
        }
        return obj;
    },
    create(base) {
        return exports.StatementFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStatementFile();
        message.fileKey = object.fileKey ?? '';
        message.displayName = object.displayName ?? '';
        return message;
    },
};
function createBaseGetMonthlyStatementsRequest() {
    return { accountId: '' };
}
exports.GetMonthlyStatementsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetMonthlyStatementsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMonthlyStatementsRequest();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseGetMonthlyStatementsResponse() {
    return { statements: [] };
}
exports.GetMonthlyStatementsResponse = {
    fromJSON(object) {
        const message = {
            statements: globalThis.Array.isArray(object?.statements)
                ? object.statements.map((e) => exports.StatementFile.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.statements?.length) {
            obj.statements = message.statements.map((e) => exports.StatementFile.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetMonthlyStatementsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetMonthlyStatementsResponse();
        message.statements = object.statements?.map((e) => exports.StatementFile.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetTradeConfirmationsRequest() {
    return { accountId: '' };
}
exports.GetTradeConfirmationsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTradeConfirmationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTradeConfirmationsRequest();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseGetTradeConfirmationsResponse() {
    return { confirmations: [] };
}
exports.GetTradeConfirmationsResponse = {
    fromJSON(object) {
        const message = {
            confirmations: globalThis.Array.isArray(object?.confirmations)
                ? object.confirmations.map((e) => exports.StatementFile.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.confirmations?.length) {
            obj.confirmations = message.confirmations.map((e) => exports.StatementFile.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTradeConfirmationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTradeConfirmationsResponse();
        message.confirmations = object.confirmations?.map((e) => exports.StatementFile.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetTaxDocumentsRequest() {
    return { accountId: '' };
}
exports.GetTaxDocumentsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTaxDocumentsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTaxDocumentsRequest();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseGetTaxDocumentsResponse() {
    return { documents: [] };
}
exports.GetTaxDocumentsResponse = {
    fromJSON(object) {
        const message = {
            documents: globalThis.Array.isArray(object?.documents)
                ? object.documents.map((e) => exports.StatementFile.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.documents?.length) {
            obj.documents = message.documents.map((e) => exports.StatementFile.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTaxDocumentsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTaxDocumentsResponse();
        message.documents = object.documents?.map((e) => exports.StatementFile.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetStatementFileRequest() {
    return { fileKey: '', accountId: '' };
}
exports.GetStatementFileRequest = {
    fromJSON(object) {
        const message = {
            fileKey: isSet(object.fileKey) ? globalThis.String(object.fileKey) : '',
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fileKey !== '') {
            obj.fileKey = message.fileKey;
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetStatementFileRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStatementFileRequest();
        message.fileKey = object.fileKey ?? '';
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseGetStatementFileResponse() {
    return { url: '' };
}
exports.GetStatementFileResponse = {
    fromJSON(object) {
        const message = {
            url: isSet(object.url) ? globalThis.String(object.url) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== '') {
            obj.url = message.url;
        }
        return obj;
    },
    create(base) {
        return exports.GetStatementFileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStatementFileResponse();
        message.url = object.url ?? '';
        return message;
    },
};
function createBaseGetViolationsSummaryRequest() {
    return {};
}
exports.GetViolationsSummaryRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetViolationsSummaryRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetViolationsSummaryRequest();
        return message;
    },
};
function createBaseViolationsSummary() {
    return { remainingViolationCount: 0, expiresAt: '0' };
}
exports.ViolationsSummary = {
    fromJSON(object) {
        const message = {
            remainingViolationCount: isSet(object.remainingViolationCount)
                ? globalThis.Number(object.remainingViolationCount)
                : 0,
        };
        if (isSet(object.expiresAt)) {
            message.expiresAt = globalThis.String(object.expiresAt);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.remainingViolationCount !== 0) {
            obj.remainingViolationCount = Math.round(message.remainingViolationCount);
        }
        if (message.expiresAt !== undefined && message.expiresAt !== '0') {
            obj.expiresAt = message.expiresAt;
        }
        return obj;
    },
    create(base) {
        return exports.ViolationsSummary.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseViolationsSummary();
        message.remainingViolationCount = object.remainingViolationCount ?? 0;
        message.expiresAt = object.expiresAt ?? '0';
        return message;
    },
};
function createBaseGetViolationsSummaryResponse() {
    return { summary: exports.ViolationsSummary.fromPartial({}) };
}
exports.GetViolationsSummaryResponse = {
    fromJSON(object) {
        const message = {
            summary: isSet(object.summary)
                ? exports.ViolationsSummary.fromJSON(object.summary)
                : exports.ViolationsSummary.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== undefined) {
            obj.summary = exports.ViolationsSummary.toJSON(message.summary);
        }
        return obj;
    },
    create(base) {
        return exports.GetViolationsSummaryResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetViolationsSummaryResponse();
        message.summary = (object.summary !== undefined && object.summary !== null)
            ? exports.ViolationsSummary.fromPartial(object.summary)
            : exports.ViolationsSummary.fromPartial({});
        return message;
    },
};
function createBaseCountry() {
    return {
        id: '',
        name: '',
        code2: '',
        code3: '',
        active: false,
        expatsAllowed: false,
        foreignTinNotRequired: false,
        fpslProhibited: false,
        taxTreatyCountry: false,
    };
}
exports.Country = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            code2: isSet(object.code2) ? globalThis.String(object.code2) : '',
            code3: isSet(object.code3) ? globalThis.String(object.code3) : '',
            active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
            expatsAllowed: isSet(object.expatsAllowed) ? globalThis.Boolean(object.expatsAllowed) : false,
            foreignTinNotRequired: isSet(object.foreignTinNotRequired)
                ? globalThis.Boolean(object.foreignTinNotRequired)
                : false,
            fpslProhibited: isSet(object.fpslProhibited)
                ? globalThis.Boolean(object.fpslProhibited)
                : false,
            taxTreatyCountry: isSet(object.taxTreatyCountry)
                ? globalThis.Boolean(object.taxTreatyCountry)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.code2 !== '') {
            obj.code2 = message.code2;
        }
        if (message.code3 !== '') {
            obj.code3 = message.code3;
        }
        if (message.active !== false) {
            obj.active = message.active;
        }
        if (message.expatsAllowed !== false) {
            obj.expatsAllowed = message.expatsAllowed;
        }
        if (message.foreignTinNotRequired !== false) {
            obj.foreignTinNotRequired = message.foreignTinNotRequired;
        }
        if (message.fpslProhibited !== false) {
            obj.fpslProhibited = message.fpslProhibited;
        }
        if (message.taxTreatyCountry !== false) {
            obj.taxTreatyCountry = message.taxTreatyCountry;
        }
        return obj;
    },
    create(base) {
        return exports.Country.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCountry();
        message.id = object.id ?? '';
        message.name = object.name ?? '';
        message.code2 = object.code2 ?? '';
        message.code3 = object.code3 ?? '';
        message.active = object.active ?? false;
        message.expatsAllowed = object.expatsAllowed ?? false;
        message.foreignTinNotRequired = object.foreignTinNotRequired ?? false;
        message.fpslProhibited = object.fpslProhibited ?? false;
        message.taxTreatyCountry = object.taxTreatyCountry ?? false;
        return message;
    },
};
function createBaseGetCountriesRequest() {
    return {};
}
exports.GetCountriesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCountriesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCountriesRequest();
        return message;
    },
};
function createBaseGetCountriesResponse() {
    return { countries: [] };
}
exports.GetCountriesResponse = {
    fromJSON(object) {
        const message = {
            countries: globalThis.Array.isArray(object?.countries)
                ? object.countries.map((e) => exports.Country.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.countries?.length) {
            obj.countries = message.countries.map((e) => exports.Country.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCountriesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCountriesResponse();
        message.countries = object.countries?.map((e) => exports.Country.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetInstrumentCategoriesRequest() {
    return {};
}
exports.GetInstrumentCategoriesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetInstrumentCategoriesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetInstrumentCategoriesRequest();
        return message;
    },
};
function createBaseGetInstrumentCategoriesResponse() {
    return { categories: [] };
}
exports.GetInstrumentCategoriesResponse = {
    fromJSON(object) {
        const message = {
            categories: globalThis.Array.isArray(object?.categories)
                ? object.categories.map((e) => stock_1.InstrumentCategory.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.categories?.length) {
            obj.categories = message.categories.map((e) => stock_1.InstrumentCategory.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetInstrumentCategoriesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetInstrumentCategoriesResponse();
        message.categories = object.categories?.map((e) => stock_1.InstrumentCategory.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetAssociatedInstrumentsRequest() {
    return { categoryId: '' };
}
exports.GetAssociatedInstrumentsRequest = {
    fromJSON(object) {
        const message = {
            categoryId: isSet(object.categoryId) ? globalThis.String(object.categoryId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.categoryId !== '') {
            obj.categoryId = message.categoryId;
        }
        return obj;
    },
    create(base) {
        return exports.GetAssociatedInstrumentsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAssociatedInstrumentsRequest();
        message.categoryId = object.categoryId ?? '';
        return message;
    },
};
function createBaseGetAssociatedInstrumentsResponse() {
    return { instruments: [] };
}
exports.GetAssociatedInstrumentsResponse = {
    fromJSON(object) {
        const message = {
            instruments: globalThis.Array.isArray(object?.instruments)
                ? object.instruments.map((e) => stock_1.InstrumentsSearchResult.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instruments?.length) {
            obj.instruments = message.instruments.map((e) => stock_1.InstrumentsSearchResult.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAssociatedInstrumentsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAssociatedInstrumentsResponse();
        message.instruments = object.instruments?.map((e) => stock_1.InstrumentsSearchResult.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseGetTrendingCategoryRequest() {
    return {};
}
exports.GetTrendingCategoryRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetTrendingCategoryRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetTrendingCategoryRequest();
        return message;
    },
};
function createBaseGetTrendingCategoryResponse() {
    return { category: stock_1.InstrumentCategory.fromPartial({}), instruments: [] };
}
exports.GetTrendingCategoryResponse = {
    fromJSON(object) {
        const message = {
            category: isSet(object.category)
                ? stock_1.InstrumentCategory.fromJSON(object.category)
                : stock_1.InstrumentCategory.fromPartial({}),
            instruments: globalThis.Array.isArray(object?.instruments)
                ? object.instruments.map((e) => stock_1.InstrumentsSearchResult.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.category !== undefined) {
            obj.category = stock_1.InstrumentCategory.toJSON(message.category);
        }
        if (message.instruments?.length) {
            obj.instruments = message.instruments.map((e) => stock_1.InstrumentsSearchResult.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTrendingCategoryResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTrendingCategoryResponse();
        message.category = (object.category !== undefined && object.category !== null)
            ? stock_1.InstrumentCategory.fromPartial(object.category)
            : stock_1.InstrumentCategory.fromPartial({});
        message.instruments = object.instruments?.map((e) => stock_1.InstrumentsSearchResult.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseAccountPerformance() {
    return {
        realizedDayPl: amount_1.Amount.fromPartial({}),
        unrealizedDayPl: amount_1.Amount.fromPartial({}),
        cumRealizedPl: amount_1.Amount.fromPartial({}),
        equity: amount_1.Amount.fromPartial({}),
        cash: amount_1.Amount.fromPartial({}),
        deposits: amount_1.Amount.fromPartial({}),
        withdrawals: amount_1.Amount.fromPartial({}),
        date: date_1.LocalDate.fromPartial({}),
    };
}
exports.AccountPerformance = {
    fromJSON(object) {
        const message = {
            realizedDayPl: isSet(object.realizedDayPl)
                ? amount_1.Amount.fromJSON(object.realizedDayPl)
                : amount_1.Amount.fromPartial({}),
            unrealizedDayPl: isSet(object.unrealizedDayPl)
                ? amount_1.Amount.fromJSON(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({}),
            cumRealizedPl: isSet(object.cumRealizedPl)
                ? amount_1.Amount.fromJSON(object.cumRealizedPl)
                : amount_1.Amount.fromPartial({}),
            equity: isSet(object.equity) ? amount_1.Amount.fromJSON(object.equity) : amount_1.Amount.fromPartial({}),
            cash: isSet(object.cash) ? amount_1.Amount.fromJSON(object.cash) : amount_1.Amount.fromPartial({}),
            deposits: isSet(object.deposits) ? amount_1.Amount.fromJSON(object.deposits) : amount_1.Amount.fromPartial({}),
            withdrawals: isSet(object.withdrawals)
                ? amount_1.Amount.fromJSON(object.withdrawals)
                : amount_1.Amount.fromPartial({}),
            date: isSet(object.date) ? date_1.LocalDate.fromJSON(object.date) : date_1.LocalDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.realizedDayPl !== undefined) {
            obj.realizedDayPl = amount_1.Amount.toJSON(message.realizedDayPl);
        }
        if (message.unrealizedDayPl !== undefined) {
            obj.unrealizedDayPl = amount_1.Amount.toJSON(message.unrealizedDayPl);
        }
        if (message.cumRealizedPl !== undefined) {
            obj.cumRealizedPl = amount_1.Amount.toJSON(message.cumRealizedPl);
        }
        if (message.equity !== undefined) {
            obj.equity = amount_1.Amount.toJSON(message.equity);
        }
        if (message.cash !== undefined) {
            obj.cash = amount_1.Amount.toJSON(message.cash);
        }
        if (message.deposits !== undefined) {
            obj.deposits = amount_1.Amount.toJSON(message.deposits);
        }
        if (message.withdrawals !== undefined) {
            obj.withdrawals = amount_1.Amount.toJSON(message.withdrawals);
        }
        if (message.date !== undefined) {
            obj.date = date_1.LocalDate.toJSON(message.date);
        }
        return obj;
    },
    create(base) {
        return exports.AccountPerformance.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountPerformance();
        message.realizedDayPl = (object.realizedDayPl !== undefined && object.realizedDayPl !== null)
            ? amount_1.Amount.fromPartial(object.realizedDayPl)
            : amount_1.Amount.fromPartial({});
        message.unrealizedDayPl =
            (object.unrealizedDayPl !== undefined && object.unrealizedDayPl !== null)
                ? amount_1.Amount.fromPartial(object.unrealizedDayPl)
                : amount_1.Amount.fromPartial({});
        message.cumRealizedPl = (object.cumRealizedPl !== undefined && object.cumRealizedPl !== null)
            ? amount_1.Amount.fromPartial(object.cumRealizedPl)
            : amount_1.Amount.fromPartial({});
        message.equity = (object.equity !== undefined && object.equity !== null)
            ? amount_1.Amount.fromPartial(object.equity)
            : amount_1.Amount.fromPartial({});
        message.cash = (object.cash !== undefined && object.cash !== null)
            ? amount_1.Amount.fromPartial(object.cash)
            : amount_1.Amount.fromPartial({});
        message.deposits = (object.deposits !== undefined && object.deposits !== null)
            ? amount_1.Amount.fromPartial(object.deposits)
            : amount_1.Amount.fromPartial({});
        message.withdrawals = (object.withdrawals !== undefined && object.withdrawals !== null)
            ? amount_1.Amount.fromPartial(object.withdrawals)
            : amount_1.Amount.fromPartial({});
        message.date = (object.date !== undefined && object.date !== null)
            ? date_1.LocalDate.fromPartial(object.date)
            : date_1.LocalDate.fromPartial({});
        return message;
    },
};
function createBaseGetAccountPerformanceRequest() {
    return { timeRange: ChartTimeRange.INVALID_CHART_TIME_RANGE };
}
exports.GetAccountPerformanceRequest = {
    fromJSON(object) {
        const message = {
            timeRange: isSet(object.timeRange)
                ? chartTimeRangeFromJSON(object.timeRange)
                : ChartTimeRange.INVALID_CHART_TIME_RANGE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.timeRange !== ChartTimeRange.INVALID_CHART_TIME_RANGE) {
            obj.timeRange = chartTimeRangeToJSON(message.timeRange);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountPerformanceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountPerformanceRequest();
        message.timeRange = object.timeRange ?? ChartTimeRange.INVALID_CHART_TIME_RANGE;
        return message;
    },
};
function createBaseGetAccountPerformanceResponse() {
    return { performances: [] };
}
exports.GetAccountPerformanceResponse = {
    fromJSON(object) {
        const message = {
            performances: globalThis.Array.isArray(object?.performances)
                ? object.performances.map((e) => exports.AccountPerformance.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.performances?.length) {
            obj.performances = message.performances.map((e) => exports.AccountPerformance.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountPerformanceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountPerformanceResponse();
        message.performances = object.performances?.map((e) => exports.AccountPerformance.fromPartial(e)) || [];
        return message;
    },
};
function chartCompressionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHART_COMPRESSION':
            return ChartCompression.INVALID_CHART_COMPRESSION;
        case 1:
        case 'DAY':
            return ChartCompression.DAY;
        case 2:
        case 'MINUTE':
            return ChartCompression.MINUTE;
        case 3:
        case 'FIVE_MINUTES':
            return ChartCompression.FIVE_MINUTES;
        case 4:
        case 'THIRTY_MINUTES':
            return ChartCompression.THIRTY_MINUTES;
        case 5:
        case 'HOUR':
            return ChartCompression.HOUR;
        case 6:
        case 'WEEK':
            return ChartCompression.WEEK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ChartCompression.UNRECOGNIZED;
    }
}
exports.chartCompressionFromJSON = chartCompressionFromJSON;
function chartCompressionToJSON(object) {
    switch (object) {
        case ChartCompression.INVALID_CHART_COMPRESSION:
            return 'INVALID_CHART_COMPRESSION';
        case ChartCompression.DAY:
            return 'DAY';
        case ChartCompression.MINUTE:
            return 'MINUTE';
        case ChartCompression.FIVE_MINUTES:
            return 'FIVE_MINUTES';
        case ChartCompression.THIRTY_MINUTES:
            return 'THIRTY_MINUTES';
        case ChartCompression.HOUR:
            return 'HOUR';
        case ChartCompression.WEEK:
            return 'WEEK';
        case ChartCompression.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.chartCompressionToJSON = chartCompressionToJSON;
function chartTimeRangeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHART_TIME_RANGE':
            return ChartTimeRange.INVALID_CHART_TIME_RANGE;
        case 1:
        case 'ONE_DAY':
            return ChartTimeRange.ONE_DAY;
        case 2:
        case 'ONE_WEEK':
            return ChartTimeRange.ONE_WEEK;
        case 3:
        case 'ONE_MONTH':
            return ChartTimeRange.ONE_MONTH;
        case 4:
        case 'THREE_MONTHS':
            return ChartTimeRange.THREE_MONTHS;
        case 5:
        case 'ONE_YEAR':
            return ChartTimeRange.ONE_YEAR;
        case 6:
        case 'FIVE_YEARS':
            return ChartTimeRange.FIVE_YEARS;
        case 7:
        case 'ALL_TIME':
            return ChartTimeRange.ALL_TIME;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ChartTimeRange.UNRECOGNIZED;
    }
}
exports.chartTimeRangeFromJSON = chartTimeRangeFromJSON;
function chartTimeRangeToJSON(object) {
    switch (object) {
        case ChartTimeRange.INVALID_CHART_TIME_RANGE:
            return 'INVALID_CHART_TIME_RANGE';
        case ChartTimeRange.ONE_DAY:
            return 'ONE_DAY';
        case ChartTimeRange.ONE_WEEK:
            return 'ONE_WEEK';
        case ChartTimeRange.ONE_MONTH:
            return 'ONE_MONTH';
        case ChartTimeRange.THREE_MONTHS:
            return 'THREE_MONTHS';
        case ChartTimeRange.ONE_YEAR:
            return 'ONE_YEAR';
        case ChartTimeRange.FIVE_YEARS:
            return 'FIVE_YEARS';
        case ChartTimeRange.ALL_TIME:
            return 'ALL_TIME';
        case ChartTimeRange.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.chartTimeRangeToJSON = chartTimeRangeToJSON;
/**
 * Stock public API.
 */
class StockServiceClient {
    rpc;
    name = 'com.step.stock.proto.StockService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/stock';
    methods = [{
            name: 'GetInstrumentDetails',
            requestType: exports.GetInstrumentDetailsRequest,
            responseType: exports.GetInstrumentDetailsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetChart',
            requestType: exports.GetChartRequest,
            responseType: exports.GetChartResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetHistoricalPriceDataDeprecated',
            requestType: exports.GetHistoricalPriceDataRequestDeprecated,
            responseType: exports.GetHistoricalPriceDataResponseDeprecated,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuotes',
            requestType: exports.GetQuotesRequest,
            responseType: exports.GetQuotesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetOrderQuote',
            requestType: exports.GetOrderQuoteRequest,
            responseType: exports.GetOrderQuoteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetNbboQuote',
            requestType: exports.GetNbboQuoteRequest,
            responseType: exports.GetNbboQuoteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAccountPositions',
            requestType: exports.GetAccountPositionsRequest,
            responseType: exports.GetAccountPositionsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAccountPerformance',
            requestType: exports.GetAccountPerformanceRequest,
            responseType: exports.GetAccountPerformanceResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateOrder',
            requestType: exports.CreateOrderRequest,
            responseType: exports.CreateOrderResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetOrder',
            requestType: exports.GetOrderRequest,
            responseType: exports.GetOrderResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetOrders',
            requestType: exports.GetOrdersRequest,
            responseType: exports.GetOrdersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CancelOrder',
            requestType: exports.CancelOrderRequest,
            responseType: exports.CancelOrderResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetMarketHours',
            requestType: exports.GetMarketHoursRequest,
            responseType: exports.GetMarketHoursResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SearchInstruments',
            requestType: exports.SearchInstrumentsRequest,
            responseType: exports.SearchInstrumentsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetUserRiskLevel',
            requestType: exports.GetUserRiskLevelRequest,
            responseType: exports.GetUserRiskLevelResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetUserRiskLevel',
            requestType: exports.SetUserRiskLevelRequest,
            responseType: exports.SetUserRiskLevelResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAccountActivity',
            requestType: exports.GetAccountActivityRequest,
            responseType: exports.GetAccountActivityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetMonthlyStatements',
            requestType: exports.GetMonthlyStatementsRequest,
            responseType: exports.GetMonthlyStatementsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTradeConfirmations',
            requestType: exports.GetTradeConfirmationsRequest,
            responseType: exports.GetTradeConfirmationsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTaxDocuments',
            requestType: exports.GetTaxDocumentsRequest,
            responseType: exports.GetTaxDocumentsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetStatementFile',
            requestType: exports.GetStatementFileRequest,
            responseType: exports.GetStatementFileResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetViolationsSummary',
            requestType: exports.GetViolationsSummaryRequest,
            responseType: exports.GetViolationsSummaryResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCountries',
            requestType: exports.GetCountriesRequest,
            responseType: exports.GetCountriesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetInstrumentCategories',
            requestType: exports.GetInstrumentCategoriesRequest,
            responseType: exports.GetInstrumentCategoriesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAssociatedInstruments',
            requestType: exports.GetAssociatedInstrumentsRequest,
            responseType: exports.GetAssociatedInstrumentsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTrendingCategory',
            requestType: exports.GetTrendingCategoryRequest,
            responseType: exports.GetTrendingCategoryResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Gets details on an instrument.
     */
    getInstrumentDetails(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets historical price data for an instrument.
     */
    getChart(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets historical price data for an instrument.
     */
    getHistoricalPriceDataDeprecated(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get delayed quotes.
     */
    getQuotes(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get order quote.
     */
    getOrderQuote(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get NBBO quote.
     */
    getNbboQuote(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns account positions.
     */
    getAccountPositions(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns an array of account performance values.
     */
    getAccountPerformance(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Creates a stock buy/sell order
     */
    createOrder(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets a stock buy/sell order
     */
    getOrder(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get pending stock buy/sell orders
     */
    getOrders(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Cancel a stock buy/sell order identified by order_id
     */
    cancelOrder(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get market hour information - whether or not the market is open AND when it would open next.
     */
    getMarketHours(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[12],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Search instruments
     */
    searchInstruments(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[13],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get user's risk level
     */
    getUserRiskLevel(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[14],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set user's risk level
     */
    setUserRiskLevel(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[15],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns activities for the user's account.
     */
    getAccountActivity(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[16],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns monthly statements for the user's account.
     */
    getMonthlyStatements(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[17],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns trade confirmations for the user's account.
     */
    getTradeConfirmations(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[18],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns tax documents for the user's account.
     */
    getTaxDocuments(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[19],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retrieve the trade confirmation, account statement or tax document file for the user's account.
     */
    getStatementFile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[20],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns stock violations summary for the user.
     */
    getViolationsSummary(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[21],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of supported countries.
     */
    getCountries(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[22],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of available instrument categories.
     */
    getInstrumentCategories(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[23],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of instruments associated with the instrument category.
     */
    getAssociatedInstruments(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[24],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns trending category details and instruments.
     */
    getTrendingCategory(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[25],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.StockServiceClient = StockServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-service.js.map